var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _vm.hasProblem
                        ? _c("v-col", { attrs: { cols: "12" } }, [
                            _vm._v(
                              "\n                         Sorry, this feature is not currently available\n                     "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isLoading && !_vm.hasProblem
                        ? _c(
                            "v-container",
                            { attrs: { fluid: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c("h2", { staticClass: "mb-3" }, [
                                      _vm._v("Reservation Confirmed"),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "Clients credit card guarantee received. Reservation Confirmed"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "All prices are in " +
                                          _vm._s(
                                            _vm.reservation.hotel.hotel_name
                                          ) +
                                          "'s local currency " +
                                          _vm._s(
                                            _vm.reservation.hotel.currency
                                              .currency_name
                                          )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.reservation.hotel.currency
                                      .currency_code != "GBP"
                                      ? _c("p", [
                                          _vm._v(
                                            "Exchange rate for this record: " +
                                              _vm._s(
                                                _vm.reservation
                                                  .quote_exchange_rate
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.reservation.hotel.currency
                                                  .currency_code
                                              ) +
                                              " to 1 GBP"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "3" } }, [
                                    _c("strong", [_vm._v("Total Rate:")]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "9" } },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { wrap: "" } },
                                        _vm._l(
                                          _vm.reservation.units,
                                          function (unit, index) {
                                            return _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(unit.room.name) +
                                                      " using " +
                                                      _vm._s(
                                                        unit.rate_type.name
                                                      ) +
                                                      ":"
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "v-container",
                                                  { attrs: { fluid: "" } },
                                                  [
                                                    _c(
                                                      "v-layout",
                                                      { attrs: { row: "" } },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass: "pa-0",
                                                            attrs: {
                                                              cols: "12",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-container",
                                                              {
                                                                attrs: {
                                                                  fluid: "",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-layout",
                                                                  {
                                                                    attrs: {
                                                                      row: "",
                                                                      wrap: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-col",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0",
                                                                        attrs: {
                                                                          cols: "6",
                                                                          sm: "3",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              "Date"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-col",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0",
                                                                        attrs: {
                                                                          cols: "6",
                                                                          sm: "3",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              "Rate (" +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .reservation
                                                                                    .hotel
                                                                                    .currency
                                                                                    .currency_code
                                                                                ) +
                                                                                ")"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " for " +
                                                                            _vm._s(
                                                                              unit.total_guests
                                                                            ) +
                                                                            " guests\n                                                          "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-col",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0",
                                                                        attrs: {
                                                                          cols: "6",
                                                                          sm: "2",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              "Total Daily Rate"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-col",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0",
                                                                        attrs: {
                                                                          cols: "6",
                                                                          sm: "2",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              "Commission Rate (%)"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-col",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0",
                                                                        attrs: {
                                                                          cols: "6",
                                                                          sm: "2",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "strong",
                                                                          [
                                                                            _vm._v(
                                                                              "Commission Amount (" +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .reservation
                                                                                    .hotel
                                                                                    .currency
                                                                                    .currency_code
                                                                                ) +
                                                                                ")"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          unit.std_rates,
                                                          function (
                                                            quoteDate,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                                attrs: {
                                                                  cols: "12",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-container",
                                                                  {
                                                                    attrs: {
                                                                      fluid: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-layout",
                                                                      {
                                                                        attrs: {
                                                                          row: "",
                                                                          wrap: "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            staticClass:
                                                                              "pa-0",
                                                                            attrs:
                                                                              {
                                                                                cols: "6",
                                                                                sm: "3",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "strong",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    quoteDate.date
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            staticClass:
                                                                              "pa-0",
                                                                            attrs:
                                                                              {
                                                                                cols: "6",
                                                                                sm: "3",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                              " +
                                                                                _vm._s(
                                                                                  quoteDate.rate.toFixed(
                                                                                    2
                                                                                  )
                                                                                ) +
                                                                                "\n                                                          "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            staticClass:
                                                                              "pa-0",
                                                                            attrs:
                                                                              {
                                                                                cols: "6",
                                                                                sm: "2",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                              " +
                                                                                _vm._s(
                                                                                  quoteDate.rate
                                                                                ) +
                                                                                "**\n                                                          "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            staticClass:
                                                                              "pa-0",
                                                                            attrs:
                                                                              {
                                                                                cols: "6",
                                                                                sm: "2",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                              " +
                                                                                _vm._s(
                                                                                  parseFloat(
                                                                                    quoteDate.commission
                                                                                  ).toFixed(
                                                                                    2
                                                                                  )
                                                                                ) +
                                                                                "\n                                                          "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            staticClass:
                                                                              "pa-0",
                                                                            attrs:
                                                                              {
                                                                                cols: "6",
                                                                                sm: "2",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                              " +
                                                                                _vm._s(
                                                                                  quoteDate.rate
                                                                                    ? Math.round(
                                                                                        (quoteDate.rate /
                                                                                          100) *
                                                                                          quoteDate.commission,
                                                                                        2
                                                                                      )
                                                                                    : "-"
                                                                                ) +
                                                                                "\n                                                          "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "3",
                                                            },
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Total Rate:"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "3",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                   " +
                                                                _vm._s(
                                                                  _vm.totalRates
                                                                ) +
                                                                "\n                                              "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "2",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                      " +
                                                                _vm._s(
                                                                  _vm
                                                                    .reservation
                                                                    .hotel
                                                                    .currency
                                                                    .currency_code
                                                                ) +
                                                                "\n                                              "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "3",
                                                            },
                                                          },
                                                          [_vm._v(" ")]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.reservation
                                                            .additional_fees,
                                                          function (fee) {
                                                            return _c(
                                                              "v-col",
                                                              {
                                                                attrs: {
                                                                  cols: "12",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                  " +
                                                                    _vm._s(
                                                                      fee.name
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      fee.fee_value
                                                                    ) +
                                                                    "\n                                              "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "3",
                                                            },
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Total Cost Inclusive:"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "9",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                 " +
                                                                _vm._s(
                                                                  parseFloat(
                                                                    _vm
                                                                      .reservation
                                                                      .quote_amount_local
                                                                  ).toFixed(2)
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm
                                                                    .reservation
                                                                    .hotel
                                                                    .currency
                                                                    .currency_code
                                                                ) +
                                                                "\n                                             "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "3" } }, [
                                    _c("strong", [_vm._v("Deposit:")]),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "9" } }, [
                                    _vm.reservation.depositRequired
                                      ? _c("div", [
                                          _c("strong", [
                                            _vm._v(
                                              "Deposit required at time of booking " +
                                                _vm._s(
                                                  parseFloat(
                                                    _vm.reservation
                                                      .deposit_amount_local
                                                  ).toFixed(2)
                                                ) +
                                                " " +
                                                _vm._s(
                                                  _vm.reservation.hotel.currency
                                                    .currency_code
                                                )
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.reservation.is_advance_payment
                                      ? _c("div", [
                                          _vm._v(
                                            "Full pre-payment charged to the client by i-escape to secure the booking"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.reservation.hotel.collect_deposit == 1
                                      ? _c("div", [
                                          _vm._v(
                                            "Amount charged to the client by i-escape to secure the booking"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "3" } }, [
                                    _c("strong", [_vm._v("Commission:")]),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "9" } }, [
                                    _c("div", [
                                      _c("strong", [
                                        _vm._v(
                                          "Charged at time of booking " +
                                            _vm._s(
                                              parseFloat(
                                                _vm.reservation
                                                  .commission_amount_local
                                              ).toFixed(2)
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.reservation.hotel.currency
                                                .currency_code
                                            )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "(i-escape's commission on Total Rate above)"
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm.reservation.voucher
                                    ? _c("v-col", { attrs: { cols: "3" } }, [
                                        _c("strong", [_vm._v("Voucher:")]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.reservation.voucher
                                    ? _c("v-col", { attrs: { cols: "9" } }, [
                                        _c("div", [
                                          _c("strong", [
                                            _vm._v(
                                              "Value Redeemed " +
                                                _vm._s(
                                                  parseFloat(
                                                    _vm.reservation.voucher
                                                      .value
                                                  ).toFixed(2)
                                                ) +
                                                " GBP"
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.reservation.voucher
                                                .voucher_code
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "important-note" },
                                          [
                                            _vm._v(
                                              "This client has booked using an i-escape voucher. Please charge the attached card the full balance payable below immediately on confirmation. If you have any problems please "
                                            ),
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: _vm.contactIescapeUrl,
                                                },
                                              },
                                              [_vm._v("contact i-escape")]
                                            ),
                                            _vm._v("."),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "3" } }, [
                                    _vm._v(
                                      "\n                                   \n                              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "9" } }, [
                                    _c("strong", [
                                      _vm._v(
                                        "Balance payable to " +
                                          _vm._s(
                                            _vm.reservation.hotel.hotel_name
                                          ) +
                                          " " +
                                          _vm._s(
                                            parseFloat(
                                              _vm.reservation
                                                .quote_amount_local -
                                                _vm.reservation
                                                  .commission_amount_local
                                            ).toFixed(2)
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.reservation.hotel.currency
                                              .currency_code
                                          )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "3" } }, [
                                    _c("strong", [_vm._v("Payment Policy:")]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "9" } },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        _vm._l(
                                          _vm.getRateTypePolicies(
                                            _vm.reservation
                                          ),
                                          function (policy) {
                                            return _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c("div", [
                                                  _c("strong", [
                                                    _vm._v(_vm._s(policy.name)),
                                                  ]),
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(_vm._s(policy.text)),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "3" } }, [
                                    _c("strong", [
                                      _vm._v("Cancellation Policy:"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "9" } },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        _vm._l(
                                          _vm.getCancellationPolicies(
                                            _vm.reservation
                                          ),
                                          function (policy) {
                                            return _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c("div", [
                                                  _c("strong", [
                                                    _vm._v(_vm._s(policy.name)),
                                                  ]),
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(_vm._s(policy.text)),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.reservation.gift
                                    ? _c("v-col", { attrs: { cols: "3" } }, [
                                        _c("strong", [
                                          _vm._v("i-escape Gift:"),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.reservation.gift
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "important-note",
                                          attrs: { cols: "9" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                  " +
                                              _vm._s(_vm.reservation.gift) +
                                              "\n                              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "no-print" },
                    [
                      _c(
                        "v-btn",
                        { on: { click: _vm.printReservation } },
                        [_c("v-icon", [_vm._v("print")]), _vm._v(" Print")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { attrs: { href: _vm.contactIescapeUrl } },
                        [
                          _c("v-icon", [_vm._v("email")]),
                          _vm._v(" Contact i-escape"),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { attrs: { href: _vm.addToCalendarUrl } },
                        [
                          _c("v-icon", [_vm._v("today")]),
                          _vm._v(" Add to Calendar"),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }